<template>
    <CustomHeader :text="$t('bauDoTesouro.treasure')" />
    <div class="bauContainer">
        <van-row class="secContainer">
            <van-col :span="24">
                <div class="menuLinkCont">
                    <div class="menuLinkWrapper">
                        <div class="linkCopy">
                            <span class="menueLinkTxt">{{ $t('common.myLink') }} {{ dataSet.activityConfig?.link }}
                            </span>
                            <img src="@/assets/themeThree/copy-icon.png" alt="" @click="handleCopyValue()">
                        </div>
                        <div class="divider" style=" top: 25%;"></div>
                        <p class="menueLinkBtTxt">{{ $t('common.quickShare') }}</p>
                        <div class="mediaListMain">
                            <div class="mediaListScroll">
                                <div v-for="(item, index) in mediaList" :key="index" class="mediaList"
                                    @click="goToShare"
                                    style="display: flex; flex-direction: column; justify-content: center;align-items: center;">
                                    <img :src="item.icon" style="height: 50.75px; width: 50.75px;" class="" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="divider" style=" top: 75%;"></div>
                        <div @click="goToUserDetails" style="position: absolute; top: 75%; width: 100%;">
                            <van-row style="padding: 0px 15px;">
                                <van-col span="15" class="myReport">
                                    <p style="">{{ $t('bauDoTesouro.myReports') }}</p>

                                    <p style="color:#F5A130;">{{
                                        dataSet.activityConfig?.valid_user_count }} {{ $t('common.pepole') }}<span
                                            style="color: #ffff">{{ ' (' + $t('common.valid') }}</span> {{ `
                                        ${dataSet.activityConfig?.valid_user_count})` }} </p>

                                </van-col>
                                <van-col span="9"
                                    style="display: flex; justify-content: flex-end; align-items: center;color: #1680dc;">
                                    <p>{{ $t('treasure.details') + ' >' }}</p>
                                </van-col>
                            </van-row>
                        </div>

                    </div>
                    <div class="recordsCard">
                        <van-row class="cardRow">
                            <div v-for="(value, index) in zigzagReordered" :key="index" class="cardCol"
                                style="width: 25%;">
                                <div v-if="!value.isNullObject">
                                    <RewardBox :peopleCount="value.valid_count" :reward="value.reward"
                                        :side="value.side" :down="value.turnDown" :isInCorner="value.isInCorner"
                                        :received="value?.received" :isLast="value.isLast" />
                                    <div class="arrow" v-if="Number(index) % 4 !== 0">
                                        <span>></span>
                                    </div>
                                </div>
                            </div>
                        </van-row>
                    </div>
                </div>
            </van-col>
        </van-row>
        <div class="rulesCard">
            <van-row style="padding: 10px;color: #6D788D;;">
                <van-col :span="24">
                    <div style="padding: .25rem 0;">
                        <span style="color: #9BA7BE;">{{ $t('mystery.effectivePromotion') }}</span>
                    </div>
                </van-col>
            </van-row>
            <div style="width: 100%; height: 1px; background: #1a233e;"></div>
            <van-row style="padding: 0px 10px 10px 10px;color: #6D788D;">
                <div class="conditionCheckContainer">
                    <van-col :span="18">
                        <span>{{ $t('mystery.requiredDeposit') }}</span>
                    </van-col>
                    <van-col :span="6" style="display: flex; justify-content: flex-end;">
                        <span style="color: #1680DC; ">{{ '≥' }}{{
                            parseFloat(dataSet.activityConfig?.recharge_require).toFixed(2).toString().replace('.', ',')
                            }}</span>
                    </van-col>
                </div>
                <div class="conditionCheckContainer">
                    <van-col :span="18">
                        <span>{{ $t('mystery.requiredTurnove') }}</span>
                    </van-col>
                    <van-col :span="6" style="display: flex; justify-content: flex-end;">
                        <span style="color: #1680DC; ">{{ '≥'
                            }}{{ parseFloat(dataSet.activityConfig?.turnover_require).toFixed(2).toString().replace('.',
                                ',') }}</span>
                    </van-col>
                </div>
                <div class="conditionCheckContainer" style="border: none;">
                    <van-col :span="18">
                        <span>{{ $t('report.ipLimit') }}</span>
                    </van-col>
                    <van-col :span="6" style="display: flex; justify-content: flex-end;">
                        <span style="color: #1680DC; ">{{ dataSet.activityConfig?.ip_limit }}</span>
                    </van-col>
                </div>
            </van-row>
        </div>
        <div class="rulesCard">
            <div class="bottom_text">
                <div class="title">{{ $t("tresure.rule") }}</div>
                <div class="line_text" v-for="(item, index) in dataSet.descriptionHtml" :key="index">
                    {{ item }}
                </div>
            </div>
        </div>
        <StatusPopup ref="statusRef" :content="$t('common.successfullyCopied')" :isShowSuccess="true" />

    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import RewardBox from './components/rewardBox.vue';
import { toZigZagWithFlags, toZigZagWithFlagsAdvance } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import { MEDIA_LIST, TreasureData } from '@/view/bauDoTesouro/supportScript';
import { copyValue } from '@/view/bauDoTesouro/supportScript'
import StatusPopup from '@/components/common/statusPopup.vue';

const mediaList = ref(MEDIA_LIST)
const statusRef = ref()
const props = defineProps<{
    dataSet: TreasureData
}>()

const emits = defineEmits(['goToShare', 'goToUserDetails'])
const zigzagReordered = computed<any>(() => {
    return props.dataSet.activityConfig?.reward_conf
})

const goToShare = async () => {
    emits('goToShare')
}
const goToUserDetails = async () => {
    emits('goToUserDetails')
}
const handleCopyValue = () => {
    copyValue(props.dataSet.activityConfig?.link, () => {
        statusRef.value?.open()
    })
}
</script>
<style scoped>
.bauContainer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    background: #090f1f;
    padding: 70px 0px 0px 0px;
}


.treasureTopImage {
    width: 100%;
    padding-top: 44px;
}

.secContainer {
    display: flex;
    justify-content: center;
    padding: 0px 15px;
    flex-direction: column;
    margin-top: 0;
}

.menuLinkWrapper {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 32vh;
    background-color: #101629;
    border-radius: 10px;
}

.linkCopy {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 95%;
    position: absolute;
    top: 5%;
    left: 5%;
}

.linkCopy img {
    width: 30px;
    margin-right: 10px;
}

.divider {
    height: 0.1px;
    width: 90%;
    background: #1a233e;

    align-items: center;
    position: absolute;
    left: 5%;
}

.myReport {
    color: #ffffffd9;
    font-size: 14px;
    line-height: 5px;
}

.inputFieldOverlay {
    position: absolute;
    top: 15%;
    width: 87%;

}

.mediaListMain {
    position: absolute;
    top: 45%;
    left: 5%;
    z-index: 1;
    width: 90%;
}

.mediaListScroll {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.mediaListScroll::-webkit-scrollbar {
    display: none;
}

.menuLinkCont {}

.rewardCard {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.menueLinkTxt {
    color: #9ba7be;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    z-index: 1;
}

.menueLinkBtTxt {
    color: #ffffffd9;
    font-size: 14px;
    position: absolute;
    top: 25%;
    left: 5%;
    display: flex;
    justify-content: flex-start;
    z-index: 1;

}

.active_channel {
    color: #fff;
    background-color: #00bbbb;
    border: 1px solid hsla(0, 0%, 100%, .45);
}

.bottom_text {
    padding: 10px;
}

.title {
    color: #fff;
    font-weight: 500;
    font-size: 1rem;
    padding: 10px 0;
}

.line_text {
    color: #6D788D;
    font-size: 13px;
    padding: 5px;
}

.recordsCard {
    padding-left: 5%;
    background: #101629;
    margin-top: 10px;
    margin-bottom: 5px;
    border-radius: 10px;
    /* max-height: 50vh; */
    overflow: hidden;

}

.conditionCheckContainer {
    padding: 10px 0;
    border-bottom: 1px solid #1a233e;
    width: 100%;
    display: flex;
    font-size: .875rem;
    font-weight: 700;
}

.rulesCard {
    /* padding-left: 5%; */
    background: #101629;
    margin-top: 2%;
    border-radius: 10px;
    /* max-height: 50vh; */
    overflow: hidden;
    margin: 5px 15px;

}

.recordsCard::-webkit-scrollbar {
    display: none;
}

.cardRow {
    background-size: contain;
    width: 100%;
}

.cardRow img {
    width: 90%;
}

.cardCol {
    position: relative;
    display: flex;
    margin-bottom: 0%;

}

.arrow {
    color: #fff;
    position: absolute;
    top: 30%;
    right: 105%;
    font-weight: 700;
    z-index: 1;
}

.arrowImgRight img {
    width: 40%;
    position: absolute;
    top: 30%;
    right: 10%;
    rotate: 180deg;
    z-index: 1;
}

.arrowDownImg img {
    width: 40%;
    position: absolute;
    bottom: -45%;
    left: 5%;
    rotate: 90deg;
}

@media (max-width:450px) {
    .arrowDownImg img {
        bottom: -15%;
        left: 15%;
    }
}
</style>